<mat-dialog-content class="mat-typography">
    <h2>
        {{ activiteAssechement.id ? 'Modification' : 'Ajout' }} d'un rapport psychométrique
    </h2>
    <form
        class="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full px-8"
        [formGroup]="activiteAssechementForm"
        (ngSubmit)="onFormSubmit()"
    >
        <mat-form-field>
            <mat-label>Plan</mat-label>
            <mat-select matSelect formControlName="etage_id">
                <mat-option *ngFor="let etage of etages" [value]="etage.id">
                    {{etage.nom_niveau}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Pièce</mat-label>
            <mat-select matSelect formControlName="piece_id">
                <mat-option *ngFor="let piece of pieces" [value]="piece.id">
                    {{piece.nom_piece}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Surface</mat-label>
            <input type="text"
                   matInput
                   formControlName="surface"
                   [matAutocomplete]="surfaceInput">
            <mat-autocomplete #surfaceInput="matAutocomplete">
                <mat-option *ngFor="let option of surfaces" [value]="option">{{option}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Matériaux</mat-label>
            <input type="text"
                   matInput
                   formControlName="material"
                   [matAutocomplete]="materialInput">
            <mat-autocomplete #materialInput="matAutocomplete">
                <mat-option *ngFor="let option of materials" [value]="option">{{option}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Technicien</mat-label>
            <mat-select matSelect formControlName="technicien_id">
                <mat-option *ngFor="let technicien of techniciens" [value]="technicien.id">
                    {{technicien.prenom + ' ' + technicien.nom}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Date de visite</mat-label>
            <input type="date" matInput formControlName="visit_date">
        </mat-form-field>

        <mat-form-field>
            <mat-label>% Humidité</mat-label>
            <input type="text" matInput formControlName="humidity">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Standard sec</mat-label>
            <input type="text" matInput formControlName="standard">
        </mat-form-field>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
